// extracted by mini-css-extract-plugin
export var core = "terms-module--core--H-rPn";